import _ from 'lodash';

const ConditionalTableElement = ({ children, shouldRender }) => {
  if (shouldRender) {
    return children;
  }
  return null;
};

export const shouldRenderSocialTableColumn = (items, platform) => _.get(items, `columns.${platform}.displayed`, true);

export default ConditionalTableElement;



/** WEBPACK FOOTER **
 ** ./src/components/conditional-table-element/index.js
 **/